import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import ChikoLogoAzul from "../static/chiko_logo_azul.png";

import {
    Box,
    Button,
    Container,
    // IconButton,
    Link,
    TextField,
    Typography,
    Toolbar,
} from "@mui/material";
// import { ArrowBack } from "@mui/icons-material";

const CreateAccountPage = () => {
    const backendEndpoint = process.env.REACT_APP_BACKEND_ENDPOINT;

    const [company, setCompany] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [password, setPassword] = useState("");
    const [passwordRepeat, setPasswordRepeat] = useState("");
    const [validate, setValidate] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const emailRegex = useMemo(() => /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/, []);
    const phoneRegex = useMemo(() => /^\(\d{2}\) \d{4,5}-\d{4}$/, []);

    const navigate = useNavigate();

    const register = useCallback(
        async (email, password, company, phoneNumber) => {
            const response = await fetch(`${backendEndpoint}/register/`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    email: email,
                    password: password,
                    company: company,
                    phoneNumber: phoneNumber,
                }),
            });

            const json = await response.json();
            const registered = json.registered;
            return registered;
        },
        [backendEndpoint],
    );

    const handleRegister = useCallback(async () => {
        setValidate(true);
        if (
            company === "" ||
            !emailRegex.test(email) ||
            !phoneRegex.test(phoneNumber) ||
            password === "" ||
            passwordRepeat === "" ||
            password !== passwordRepeat
        ) {
            setError(true);
            setErrorMessage("");
            return;
        }

        const registered = await register(
            email,
            password,
            company,
            phoneNumber,
        );

        if (registered) {
            navigate("/training");
        } else {
            setError(true);
            setErrorMessage("Este e-mail já está registrado.");
            return;
        }
    }, [
        navigate,
        register,
        emailRegex,
        email,
        password,
        passwordRepeat,
        company,
        phoneRegex,
        phoneNumber,
    ]);

    const cleanValidations = () => {
        setValidate(false);
        setError(false);
        setErrorMessage("");
    };

    const formatPhone = (value) => {
        value = value.replace(/\D/g, "");
        if (value.length > 0 && value.length < 3) {
            value = value.replace(/^(\d{1,2})/, "($1");
        } else if (value.length < 7) {
            value = value.replace(/^(\d{2})(\d{0,4})/, "($1) $2");
        } else if (value.length < 11) {
            value = value.replace(/^(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
        } else {
            value = value.replace(/^(\d{2})(\d{5})(\d{4}).*/, "($1) $2-$3");
        }
        return value;
    };

    const getCookieValue = useCallback(
        (name) =>
            document.cookie
                .match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")
                ?.pop() || "",
        [],
    );

    const authenticate = useCallback(async () => {
        const response = await fetch(`${backendEndpoint}/authenticate/`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": getCookieValue("csrfToken"),
            },
        });

        const { authenticated } = await response.json();

        return authenticated;
    }, [backendEndpoint, getCookieValue]);

    useEffect(() => {
        const run = async () => {
            const csrfToken = getCookieValue("csrfToken");

            if (csrfToken) {
                const authenticated = await authenticate();
                if (authenticated) {
                    navigate("/training");
                }
            }
        };
        run();
    }, [getCookieValue, authenticate, navigate]);

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    mt: "30px",
                }}
            >
                {/* <Box sx={{ width: "100%" }}>
                    <IconButton
                        title="voltar"
                        edge="end"
                        aria-label="edit"
                        onClick={() => navigate("/")}
                    >
                        <ArrowBack />
                    </IconButton>
                </Box> */}
                <Toolbar
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        mt: 2,
                        mb: 5,
                    }}
                >
                    <img src={ChikoLogoAzul} alt="Chiko Logo" height="80" />
                </Toolbar>
                <Typography variant="div" gutterBottom>
                    Seja bem vindo!
                </Typography>

                <TextField
                    value={company}
                    onChange={(e) => {
                        setCompany(e.target.value);
                        cleanValidations();
                    }}
                    label="Nome da empresa"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    error={validate && company === "" ? true : false}
                    helperText={
                        validate && company === ""
                            ? "Preencha o nome da sua empresa"
                            : ""
                    }
                />

                <TextField
                    value={email}
                    onChange={(e) => {
                        setEmail(e.target.value);
                        cleanValidations();
                    }}
                    label="Digite seu e-mail"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    error={validate && !emailRegex.test(email) ? true : false}
                    helperText={
                        validate && !emailRegex.test(email)
                            ? "Preencha com um e-mail válido"
                            : ""
                    }
                />

                <TextField
                    value={phoneNumber}
                    onChange={(e) => {
                        setPhoneNumber(formatPhone(e.target.value));
                        cleanValidations();
                    }}
                    label="Número de WhatsApp"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    error={
                        validate && !phoneRegex.test(phoneNumber) ? true : false
                    }
                    helperText={
                        validate && !phoneRegex.test(phoneNumber)
                            ? "Preencha com um número de WhatsApp válido"
                            : ""
                    }
                />

                <TextField
                    value={password}
                    onChange={(e) => {
                        setPassword(e.target.value);
                        cleanValidations();
                    }}
                    label="Crie sua senha"
                    type="password"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    error={validate && password === "" ? true : false}
                    helperText={
                        validate && password === "" ? "Preencha sua senha" : ""
                    }
                />

                <TextField
                    value={passwordRepeat}
                    onChange={(e) => {
                        setPasswordRepeat(e.target.value);
                        cleanValidations();
                    }}
                    label="Repita sua senha"
                    type="password"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    error={validate && passwordRepeat === "" ? true : false}
                    helperText={
                        validate &&
                        (passwordRepeat === "" || passwordRepeat !== password)
                            ? "Preencha sua senha novamente corretamente"
                            : ""
                    }
                />

                {error ? (
                    <Typography variant="h6">{errorMessage}</Typography>
                ) : null}

                <Button
                    variant="contained"
                    color="primary"
                    sx={{ marginTop: 2, padding: "14px !important" }}
                    fullWidth
                    component={Link}
                    onClick={() => handleRegister()}
                >
                    Criar conta
                </Button>

                <Box
                    sx={{
                        color: "#bbb",
                        margin: "20px 0",
                    }}
                >
                    ________________
                </Box>
                <Box>
                    Já tem conta? &nbsp;
                    <Link
                        variant="text"
                        sx={{
                            textDecoration: "none",
                            ":hover": { cursor: "pointer" },
                        }}
                        href="/"
                    >
                        Acesse por aqui
                    </Link>
                </Box>

                <Box
                    sx={{
                        mt: "30px",
                        color: "#ccc",
                        fontSize: "12px",
                    }}
                >
                    <Link
                        variant="text"
                        sx={{
                            color: "#aaa",
                            textDecoration: "none",
                            ":hover": { cursor: "pointer" },
                        }}
                        href="https://www.chiko.ai/politica-de-privacidade"
                        target="_blank"
                    >
                        Politica de privacidade
                    </Link>
                    &nbsp;&nbsp;|&nbsp;&nbsp;
                    <Link
                        variant="text"
                        sx={{
                            color: "#aaa",
                            textDecoration: "none",
                            ":hover": { cursor: "pointer" },
                        }}
                        href="https://www.chiko.ai/termos-de-uso"
                        target="_blank"
                    >
                        Termos de uso
                    </Link>
                </Box>
            </Box>
        </Container>
    );
};

export default CreateAccountPage;
